import config from '@/config'
import Search, { ISearch } from '@/models/search'
import { useGlobalStore } from '@/store/app'
import BaseService from './BaseService'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

const http = requests(config?.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('groupId')
class SearchServiceCls extends BaseService<Search> {
  constructor() {
    super(null as any)
  }

  model() {
    return Search
  }

  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/${appStore.locationId}/groups/${appStore.groupId}`
  }

  async getSearchDiscussionResults(
    query: string,
    queryParams: Record<string, any>
  ): Promise<ISearch[]> {
    const response = await http.get(`${this.endpoint}/search`, {
      params: { query, ...queryParams },
    })
    return response.data
  }

  async getSearchDiscussionResultsByChannel(
    query: string,
    queryParams: Record<string, any>,
    channelId: string
  ): Promise<ISearch[]> {
    const response = await http.get(
      `${this.endpoint}/channels/${channelId}/search`,
      {
        params: { query, ...queryParams },
      }
    )
    return response.data
  }

  async getUserContributions(
    contactId: string,
    lastPaginatedId: string,
    limit: number,
    contributionType?: string
  ): Promise<{
    contributions: ISearch[]
    total: number
    lastPaginatedId: string
  }> {
    const response = await http.get(
      `${this.endpoint}/users/${contactId}/contributions`,
      {
        params: { limit, lastPaginatedId, contributionType },
      }
    )
    return response.data
  }

  async getUserContributionsCount(contactId: string): Promise<number> {
    const response = await http.get(
      `${this.endpoint}/users/${contactId}/contributions/count`
    )
    return response.data
  }
}

// Export singleton instance
export const SearchService = new SearchServiceCls()

// Export type for dependency injection
export type ISearchService = SearchServiceCls

// Export commonly used methods directly
export const {
  getSearchDiscussionResults,
  getSearchDiscussionResultsByChannel,
} = SearchService

// Hook exports
export const useSearchService = () => {
  return {
    getSearchDiscussionResults:
      SearchService.getSearchDiscussionResults.bind(SearchService),
    getSearchDiscussionResultsByChannel:
      SearchService.getSearchDiscussionResultsByChannel.bind(SearchService),
  }
}
